import { deleteUndefinedOrNullProperties } from 'legacy/lut/helpers/deleteUndefinedOrNullProperties'

import { IPartner } from 'clickNgo/entities/partner/models'
import { I406Form } from 'clickNgo/models/crud/forms/i406Form'

export const mapPartnerFrom406Crud = (data: I406Form): Partial<IPartner> => {
  const mappedData = {
    partnerId: data.PartnerID,
    entryId406: data.EntryId,
    addressLine1: data.AddressLine1,
    addressLine2: data.AddressLine2,
    addressLine3: data.AddressLine3,
    city: data.City,
    communicationName: data.CommunicationName,
    country: data.Country,
    email: data.Email,
    locationId: data.LocationID,
    state: data.State,
    taxId: data.TaxID,
    url: data.URL,
    zipCode: data.ZIPCode,
    phone: data.MainPhone,
    phoneCountryCode: data.MainPhoneCountryCode,
    modifiedValues: data.ModifiedValues ? data.ModifiedValues?.split(',') : [],
    profileTeamComment: data.ProfileTeamComment,
    approveComment: data.ProfileApproverComment,
    workflowStatus: data.WorkflowStatus,
    topPartnerId: data.TopPartnerID,
    hierarchyType: data.Hierarchy,
    market: data.Market,
    source: data.Source,
    sourceRequester: data.SourceRequestor,
    storeNumber: data.StoreNumber,
    status: data.Status,
    modified: data.Modified,
    companyLegalName: data.CompanyLegalName,
    companyEnglishName: data.CompanyEnglishName,
    companyLegalNameNonLatin: data.CompanyLegalNameNonLatin,
    legalAddressLine1: data.LegalAddr1,
    legalAddressLine2: data.LegalAddr2,
    legalAddressLine3: data.LegalAddr3,
    legalCity: data.LegalCity,
    legalCountry: data.LegalCountry,
    legalState: data.LegalState,
    legalZipCode: data.LegalPostalCode,
  }

  return deleteUndefinedOrNullProperties(mappedData)
}
